/**
 * Geographical context as persisted on records (see confirm flow / Firestore).
 */

export interface StoredGeographicalAddress {
  formatted_address?: string;
}

export interface StoredGeographicalStreet {
  formatted_street?: string;
}

export interface StoredRatingValuation {
  valuation_reference_number?: string;
  assessment_id?: string;
  image_url?: string;
}

export interface StoredParcel {
  parcel_id?: string;
  status?: string;
  appellation?: string;
}

export interface StoredGeographicalContext {
  addresses?: StoredGeographicalAddress[];
  street?: StoredGeographicalStreet | null;
  rating_valuations?: StoredRatingValuation[];
  parcels?: StoredParcel[];
}

export function getStoredGeographicalContextLines(
  gc?: StoredGeographicalContext | null,
): string[] {
  if (!gc) return [];
  const lines: string[] = [];
  for (const a of gc.addresses ?? []) {
    const fa = a?.formatted_address?.trim();
    if (fa) lines.push(fa);
  }
  const fs = gc.street?.formatted_street?.trim();
  if (fs) lines.push(fs);
  return lines;
}

/** First line suitable for PNCC GIS "find" (same ordering as search result geo lines). */
export function gisFindQueryFromStored(gc?: StoredGeographicalContext | null): string {
  const lines = getStoredGeographicalContextLines(gc);
  return lines[0] ?? '';
}

export function hasStoredGeographicalContext(gc?: StoredGeographicalContext | null): boolean {
  if (!gc) return false;
  if ((gc.addresses?.length ?? 0) > 0) return true;
  if (gc.street?.formatted_street?.trim()) return true;
  if ((gc.rating_valuations?.length ?? 0) > 0) return true;
  if ((gc.parcels?.length ?? 0) > 0) return true;
  return false;
}

export function getStoredGeographicalContextDisplayAddress(
  gc?: StoredGeographicalContext | null,
): string | null {
  const lines = getStoredGeographicalContextLines(gc);
  return lines[0] ?? null;
}
